<template>
  <a @click="scrollTop" v-show="visible" class="bottom-right">
    <font-awesome-icon icon="arrow-up" size="3x"></font-awesome-icon>
  </a>
</template>

<script>
  export default {
    data(){
      return {
        visible: false
      }
    },
    methods:{
      scrollTop: function(){
        this.intervalId = setInterval(() => {
          if(window.pageYOffset === 0 ){
            clearInterval(this.intervalId)
          }
          window.scroll(0, window.pageYOffset - 50)
        }, 20);
      },
      scrollListener: function(){
        this.visible = window.scrollY > 50
      }
    },
    mounted: function(){
      window.addEventListener('scroll', this.scrollListener)
    },
    beforeDestroy: function () {
      window.removeEventListener('scroll', this.scrollListener)
    }
  }
</script>

<style scoped>
.bottom-right{
  position: fixed;
  bottom: 20px;
  right: 20px;
  cursor: pointer;
  background-color: #ff9917;
  border-radius: 50%;
  width: 3rem;
  height: 3rem;
  color: white !important;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.7em;
}

</style>